import { useAdminStore } from '@/stores/adminStore';

function typeBadge(type: string) {
  const styles: Record<string, string> = {
    token_expired: 'bg-accent-orange/15 text-accent-orange',
    query_failed: 'bg-accent-red/15 text-accent-red',
    smtp_error: 'bg-accent-purple/15 text-accent-purple',
    system: 'bg-bg-tertiary text-text-muted',
  };
  const labels: Record<string, string> = {
    token_expired: 'Token expirado',
    query_failed: 'Query fallida',
    smtp_error: 'SMTP',
    system: 'Sistema',
  };
  return (
    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${styles[type] || 'bg-bg-tertiary text-text-muted'}`}>
      {labels[type] || type}
    </span>
  );
}

export default function ErrorLogTab() {
  const errors = useAdminStore((s) => s.errorLog);

  if (errors.length === 0) {
    return (
      <div className="text-center text-text-muted text-sm py-12">
        Sin errores recientes
      </div>
    );
  }

  return (
    <div className="space-y-1.5">
      {errors.map((err, i) => (
        <div
          key={`${err.timestamp}-${i}`}
          className="px-3 py-2 bg-bg-tertiary/50 border border-border-subtle rounded-lg"
        >
          <div className="flex items-center justify-between gap-2 mb-1">
            <div className="flex items-center gap-2">
              {typeBadge(err.type)}
              {err.username && (
                <span className="text-xs text-text-secondary">{err.username}</span>
              )}
            </div>
            <span className="text-[10px] text-text-subtle font-mono">
              {new Date(err.timestamp).toLocaleTimeString()}
            </span>
          </div>
          <div className="text-[11px] text-text-muted truncate">{err.message}</div>
        </div>
      ))}
    </div>
  );
}
